// Suivi anonyme des pages vues du portail public (voir backend/src/routes/stats.routes.js).
// Aucun cookie, aucune adresse IP : un identifiant aleatoire est garde dans le navigateur
// uniquement pour compter les visiteurs distincts. Echoue en silence, ne gene jamais la page.
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const KEY = 'visitor_id';

export function visitorId() {
  try {
    let id = localStorage.getItem(KEY);
    if (!id) {
      id = (window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2, 12)}`).slice(0, 40);
      localStorage.setItem(KEY, id);
    }
    return id;
  } catch {
    return null; // stockage bloque : on ne suit pas
  }
}

// Partie de quiz terminee (voir backend/src/routes/stats.routes.js).
export function trackQuizPlay(score, total) {
  try {
    if (navigator.doNotTrack === '1') return;
    const visitor = visitorId();
    if (!visitor) return;
    fetch(`${API_URL}/stats/quiz`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ visitor, score, total }),
      keepalive: true,
    }).catch(() => {});
  } catch { /* sans effet sur le quiz */ }
}

export function trackPageView(path) {
  try {
    if (navigator.doNotTrack === '1') return;
    const visitor = visitorId();
    if (!visitor) return;
    const device = window.matchMedia && window.matchMedia('(max-width: 768px)').matches ? 'mobile' : 'desktop';
    fetch(`${API_URL}/stats/pageview`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ path, visitor, device }),
      keepalive: true,
    }).catch(() => {});
  } catch { /* le suivi ne doit jamais casser la page */ }
}
